import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { MissionStandard } from '@carers/models/RequestAndMission';
import missionQueries from '@carers/views/Missions/utils/missionQueryFactory';
import { httpService } from '@shared/httpService';

type reportSchedulesProblemDTO = {
  missionId: MissionStandard['id'];
  reason: string;
  comment: string;
};

const putReportSchedulesProblem = async ({
  missionId,
  reason,
  comment,
}: reportSchedulesProblemDTO) => {
  const url = `/missions/${missionId}/report-schedule-problem`;

  const response = await httpService.put<{ missionId: string }>(url, { reason, comment });

  return response.data.missionId;
};

const useReportSchedulesProblem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: putReportSchedulesProblem,
    onSettled(data, error) {
      queryClient.removeQueries({ queryKey: missionQueries.all() });

      if (error?.code === AxiosError.ERR_NETWORK) {
        return null;
      }

      return Promise.all([
        ...[],
        queryClient.invalidateQueries({ queryKey: missionQueries.lists(), refetchType: 'all' }),
      ]);
    },
  });
};

export default useReportSchedulesProblem;
